import { Navigate, useLocation } from 'react-router-dom';

/**
 * Componente para proteger las rutas de administración.
 * Verifica la existencia de un token en localStorage.
 */
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const location = useLocation();

  if (!token || !user) {
    // Redirigir a login pero guardando la ubicación intentada
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  // Si existe el token, permitir el acceso
  return children;
};

export default ProtectedRoute;
